<template>
	<div v-if="enabled">
		<div ref="recaptchaContainer" class="recaptcha-container"></div>

		<p v-if="loadError" class="caption error--text">
			{{ loadError }}
		</p>
	</div>
</template>

<script>
import {
	isRecaptchaEnabled,
	renderRecaptcha,
	getRecaptchaSiteKey,
} from "../utils/recaptcha"

export default {
	name: "RecaptchaWidget",

	data() {
		return {
			enabled: isRecaptchaEnabled(),
			widgetId: null,
			loadError: null,
			token: "",
		}
	},

	mounted() {
		console.log("reCAPTCHA enabled:", this.enabled)
		console.log("Site key:", getRecaptchaSiteKey())

		if (!this.enabled) return

		this.$nextTick(() => {
			renderRecaptcha(this.$refs.recaptchaContainer, {
				theme: "light",
				size: "normal",

				callback: (token) => {
					this.token = token
					this.$emit("verified", token)
				},

				"expired-callback": () => {
					this.token = ""
				},

				"error-callback": () => {
					this.loadError = "reCAPTCHA verification failed"
				},
			})
				.then((id) => {
					this.widgetId = id
					this.$emit("ready", id)
				})
				.catch((err) => {
					this.loadError =
						err.message || "reCAPTCHA could not be loaded"
				})
		})
	},

	methods: {
		getToken() {
			if (!window.grecaptcha || this.widgetId == null) return ""
			return window.grecaptcha.getResponse(this.widgetId)
		},

		reset() {
			if (
				this.enabled &&
				window.grecaptcha &&
				this.widgetId != null
			) {
				window.grecaptcha.reset(this.widgetId)
				this.token = ""
			}
		},
	},
}
</script>

<style scoped>
.recaptcha-container {
	min-height: 78px;
}
</style>